import DSDialogContent from '../design-system/DSDialogContent';
import { DSTypography } from '../design-system/Typography';
import DSDialogActions from '../design-system/DSDialogActions';
import DSSecondaryButton from '../design-system/DSSecondaryButton';
import DSPrimaryButton from '../design-system/DSPrimaryButton';
import DSDialog from '../design-system/DSDialog';

type DeleteDialogProps = {
  deleteMessage: string;
  isDeleteDialogOpen: boolean;
  handleConfirmationClick: () => void;
  handleClose: () => void;
  isDeleting?: boolean;
};
const DeleteDialog = ({
  deleteMessage,
  isDeleteDialogOpen,
  handleConfirmationClick,
  handleClose,
  isDeleting,
}: DeleteDialogProps) => {
  return (
    <DSDialog maxWidth="md" open={isDeleteDialogOpen}>
      <DSDialogContent>
        <DSTypography variant="body2" color="text.primary">
          {deleteMessage}
        </DSTypography>
        <DSTypography variant="body2">
          {isDeleting && 'Deleting...'}
        </DSTypography>
      </DSDialogContent>
      <DSDialogActions>
        <DSSecondaryButton disabled={isDeleting} onClick={() => handleClose()}>
          Cancel
        </DSSecondaryButton>
        <DSPrimaryButton
          disabled={isDeleting}
          onClick={() => handleConfirmationClick()}
        >
          Yes
        </DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};
export default DeleteDialog;
